const config = {
    api: {
        version: 'v1',
    },
}

//Return the config as a promise
module.exports = config
